import script from "./TagChip.vue?vue&type=script&setup=true&lang=js"
export * from "./TagChip.vue?vue&type=script&setup=true&lang=js"

import "./TagChip.vue?vue&type=style&index=0&id=566d81aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566d81aa"]])

export default __exports__